export function getExportFilename(type: 'csv' | 'xlsx' = 'csv') {
  const now = new Date().toLocaleString('no');
  return `ebba-export-${now}.${type}`;
}
